import { useState, useMemo } from 'react';
import { useIsomorphicLayoutEffect } from 'common/hooks/use-isomorphic-layout-effect';

export const useOffset = (dataSelector: string, cb: (height: number) => void) => {
  const intersectionObserver: IntersectionObserver | null = useMemo(() => {
    if (__IS_SERVER__) {
      return null;
    }

    return new IntersectionObserver(
      ([entry]) => {
        const offset = entry.isIntersecting ? entry.target.clientHeight : 0;
        cb(offset);
      },
      { threshold: 0.5 }
    );
  }, [cb]);

  useIsomorphicLayoutEffect(() => {
    const header = document.querySelector(`[${dataSelector}]`);
    if (header) {
      intersectionObserver?.observe(header);
    }

    return () => {
      intersectionObserver?.disconnect();
    };
  }, [intersectionObserver]);
};

export const useBottomOffset = () => {
  const [bottomOffset, setBottomOffset] = useState<number>(0);
  useOffset('data-qa="mobile-fixed-menu"', setBottomOffset);

  return bottomOffset;
};

export const useTopOffset = () => {
  const [topOffset, setTopOffset] = useState<number>(0);
  useOffset('data-component-content="sticky-header"', setTopOffset);

  return topOffset;
};
